import React from 'react'
import styled from 'styled-components'
import { string, number, object } from 'prop-types'

import { primaryTextColor } from './colors'

const StyledText = styled.span`
  color: ${({ color }) => color};
  font-size: ${({ size }) => size}px;
  font-weight: ${({ weight }) => weight};
`

const Text = ({
  color = primaryTextColor,
  weight = 300,
  size = 14,
  style,
  className,
  children,
  onClick = () => {},
}) => (
  <StyledText
    color={color}
    weight={weight}
    size={size}
    style={style}
    className={className}
    onClick={onClick}
  >
    {children}
  </StyledText>
)

Text.propTypes = {
  color: string,
  weight: string,
  size: number,
  style: object,
  className: string,
}

export default Text
